import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Modal = styled.div`
  background: ${props => props.$darkMode ? '#161b22' : 'white'};
  border-radius: 12px;
  padding: 32px;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  animation: slideUp 0.3s;
  border: 1px solid ${props => props.$darkMode ? '#30363d' : '#d0d7de'};
  
  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const Icon = styled.div`
  font-size: 48px;
  text-align: center;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 600;
  color: ${props => props.$darkMode ? '#e6edf3' : '#24292f'};
  text-align: center;
`;

const Message = styled.p`
  margin: 0 0 24px 0;
  font-size: 14px;
  color: ${props => props.$darkMode ? '#8b949e' : '#57606a'};
  text-align: center;
  line-height: 1.6;
`;

const Buttons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const Button = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.$primary ? `
    background: #0969da;
    color: white;
    &:hover {
      background: #0860ca;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(9,105,218,0.3);
    }
  ` : props.$danger ? `
    background: #cf222e;
    color: white;
    &:hover {
      background: #bc1e2a;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(207,34,46,0.3);
    }
  ` : `
    background: ${props => props.$darkMode ? '#21262d' : '#f6f8fa'};
    color: ${props => props.$darkMode ? '#e6edf3' : '#24292f'};
    border: 1px solid ${props => props.$darkMode ? '#30363d' : '#d0d7de'};
    &:hover {
      background: ${props => props.$darkMode ? '#30363d' : '#eaeef2'};
    }
  `}
`;

const ConfirmModal = ({ type = 'confirm', title, message, onConfirm, onCancel, darkMode = false }) => {
  const icons = {
    confirm: '❓',
    success: '✅',
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️'
  };

  return (
    <Overlay onClick={onCancel}>
      <Modal $darkMode={darkMode} onClick={e => e.stopPropagation()}>
        <Icon>{icons[type]}</Icon>
        <Title $darkMode={darkMode}>{title}</Title>
        <Message $darkMode={darkMode}>{message}</Message>
        <Buttons>
          {type === 'confirm' || type === 'warning' ? (
            <>
              <Button $darkMode={darkMode} onClick={onCancel}>Cancel</Button>
              <Button $darkMode={darkMode} $danger={type === 'warning'} $primary={type === 'confirm'} onClick={onConfirm}>
                {type === 'warning' ? 'Delete' : 'Confirm'}
              </Button>
            </>
          ) : (
            <Button $darkMode={darkMode} $primary onClick={onConfirm}>OK</Button>
          )}
        </Buttons>
      </Modal>
    </Overlay>
  );
};

export default ConfirmModal;
